import "./index.less";
import React, { useState } from "react";
import { Button, Row, Col } from "antd";
import moment from "moment";
import WeChatServicesModal from "@/components/dialogs/WeChatServicesModal";
import { useModalStore } from "@/hooks/Modal/hooks";
import { wangwangService } from "@/services/customerServices";
import { getVersion } from "@/services/version";
import { AddShopTutorial } from "@/utils/Url";

const NewHelpCenter: React.FC = React.memo(function () {
    const [now] = useState(moment());

    const modalStore = useModalStore();

    const hide = now.isAfter(moment("2023-01-17 21:00:00")) && now.isBefore(moment("2023-01-28 10:00:00"));

    return (
        <>
            <div className="ec-help-center-container">
                <div style={{ padding: "0px 0 5px 0" }}>
                    <div style={{ fontSize: 17 }}>
                        {!hide ? (
                            <>
                                <span className="font-bold" style={{ paddingRight: 20 }}>
                                    客服（9:00-12:00、13:00-21:00）
                                </span>

                                <div style={{ display: "inline-block", paddingRight: 30 }}>
                                    旺旺：
                                    <a target="_blank" href={wangwangService.url}>
                                        <img
                                            src={wangwangService.icon}
                                            alt="点击这里给我发消息"
                                            title="点击这里给我发消息"
                                        />
                                    </a>
                                </div>

                                <div style={{ display: "inline-block", paddingRight: 20 }}>
                                    Q Q：800183878
                                    <a target="_blank" href="http://q.url.cn/ab3QoS?_type=wpa&qidian=true">
                                        <img
                                            src="https://wpa.qq.com/pa?p=2:800183878:51"
                                            alt="点击这里给我发消息"
                                            title="点击这里给我发消息"
                                        />
                                    </a>
                                </div>

                                <div style={{ display: "inline-flex", paddingRight: 20, alignItems: "center" }}>
                                    微信客服：
                                    <a
                                        id="showWeixinCsDialog"
                                        href="javascript:void(0);"
                                        onClick={() => modalStore.openModal(WeChatServicesModal)}
                                    >
                                        <img
                                            src="https://img.alicdn.com/imgextra/i3/54458674/O1CN01jSsfFG2DwkBD9S6SG_!!54458674.png"
                                            alt="点击这里给我发消息"
                                            title="点击这里给我发消息"
                                        />
                                    </a>
                                </div>

                                <div style={{ display: "inline-block" }}>
                                    <Button href="https://wj.qq.com/s2/11784179/1c63/" target="_blank" danger>
                                        客服投诉
                                    </Button>
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>

                <Row>
                    <Col span={18}>
                        <div className="iframe">
                            <iframe
                                src="https://openai.weixin.qq.com/webapp/GL5BcjPA02yM4DogvSXjDmqJuRZMUV?robotName=%E5%8F%91%E8%B4%A7%E6%98%93%E6%99%BA%E8%83%BD%E5%AE%A2%E6%9C%8D&hcrt=1"
                                scrolling="no"
                                frameBorder="0"
                            />
                        </div>
                    </Col>

                    <Col span={6}>
                        <div className="questions-container">
                            <div>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        window.open(
                                            "https://qw15p3s8hv.feishu.cn/wiki/wikcnktyZKjJw5x3Ni2CbX9gRQh?fromScene=spaceOverview",
                                            "_blank",
                                        );
                                    }}
                                >
                                    查看更多教程
                                </Button>
                            </div>
                            <div className="page-header">常见问题</div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnktyZKjJw5x3Ni2CbX9gRQh" target="_blank">
                                    打印发货视频教程
                                </a>
                            </div>
                            <div className="mb5">
                                <a href={AddShopTutorial} target="_blank">
                                    多店铺关联
                                </a>
                            </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcncB5Ji6FahvJOStyb60ay0g" target="_blank">
                                    手工添加/批量导入订单打印
                                </a>
                            </div>
                            <div className="page-header">电子面单 </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcn7I3SUsF7BpkaFfdpj8kZxf" target="_blank">
                                    开通电子面单
                                </a>
                            </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnypvvxrZivF9LsBUHmS5Pti" target="_blank">
                                    查电子面单余额
                                </a>
                            </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnWx534tyRd19eu5TLrrmpQ8" target="_blank">
                                    下载打印组件
                                </a>
                            </div>
                            <div className="page-header">打印机 </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnEd7bb9mUkFT7RAxxWZc5Kh" target="_blank">
                                    打印快递单打印机没反应
                                </a>
                            </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcn7D6BWX7v83albP7t4Vf4Ph" target="_blank">
                                    常见打印机驱动下载地址
                                </a>
                            </div>
                            <div className="page-header">设置 </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnUXa6QubCidbGzw0WmrXpxD" target="_blank">
                                    商品简称、重量设置
                                </a>
                            </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnuEYg3yoOB05SvNGRdGKJce" target="_blank">
                                    快递单模板编辑
                                </a>
                            </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnWpSxhtOuBhHmpamv9JoD2b" target="_blank">
                                    添加、修改发货人信息
                                </a>
                            </div>
                            <div className="mb5">
                                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnY3fmofQW3S1WyEX3j5FIFe" target="_blank">
                                    淘宝子账号应用授权设置
                                </a>
                            </div>
                            <div className="text-light2 mt10 small">VER: {getVersion()}</div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
});

export default NewHelpCenter;
